import { useMutation, useQueryClient } from '@tanstack/react-query';
import { billingService } from '@/services/billing/billingService';
import { billingKeys } from './queryKeys';
import { toast } from 'sonner';

export const useBillingMutations = () => {
  const queryClient = useQueryClient();

  const createPortalSession = useMutation({
    mutationFn: () => billingService.createPortalSession(),
    onSuccess: (data) => {
      // Open portal in new tab
      window.open(data.url, '_blank');
      toast.success('Billing portal opened successfully');
    },
    onError: (error: Error) => {
      console.error('Error creating portal session:', error);
      toast.error(error.message || 'Failed to open billing portal. Please try again.');
    },
  });

  return {
    createPortalSession,
  };
};
